module.exports = __webpack_public_path__ + "static/media/23-skylle.09dfed71.mp3";